import { Template } from "../utils/helper";
class ClientSideLoginPage extends HTMLElement {
    form = null;
    handleSubmit = null;
    constructor() {
        super();
        new Template().createTemplate(ClientSideLoginPage.template(), this);
    }
    static template() {
        return `
            <section class="d-flex flex-row align-items-center justify-content-center" style="min-height: 100dvh; background: var(--clr-one);">
                <form id="loginForm" class="d-flex flex-column gap-3 p-4 w-100" style="max-width: 400px;">
                    <h2 class="text-center fw-bold mb-2" style="color: var(--clr-two);">Admin Login</h2>

                    <div class="d-flex flex-column gap-1">
                        <label for="username" class="form-label fw-medium" style="color: var(--clr-two);">Username</label>
                        <input
                            type="text"
                            id="username"
                            name="username"
                            class="form-control form-control-lg rounded-5"
                            placeholder="Enter username"
                            autocomplete="username"
                            required
                        >
                    </div>

                    <div class="d-flex flex-column gap-1">
                        <label for="password" class="form-label fw-medium" style="color: var(--clr-two);">Password</label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            class="form-control form-control-lg rounded-5"
                            placeholder="Enter password"
                            autocomplete="current-password"
                            required
                        >
                    </div>

                    <div id="loginError" class="text-danger text-center fw-medium" style="display: none;"></div>

                    <button
                        type="submit"
                        id="loginSubmitBtn"
                        class="bee-color-btn bg-gradient btn btn-lg rounded-5 fw-bold shadow-sm"
                    >
                        Login
                    </button>

                    <a href="/" class="text-center text-decoration-none fw-medium" style="color: var(--clr-two);">
                        &larr; Back to portfolio
                    </a>
                </form>
            </section>
        `;
    }
    connectedCallback() {
        this.form = this.querySelector("#loginForm");
        this.handleSubmit = this.onSubmit.bind(this);
        this.form?.addEventListener("submit", this.handleSubmit);
    }
    disconnectedCallback() {
        this.form?.removeEventListener("submit", this.handleSubmit);
    }
    async onSubmit(e) {
        e.preventDefault();
        const btn = this.querySelector("#loginSubmitBtn");
        const username = this.querySelector("#username").value.trim();
        const password = this.querySelector("#password").value;
        this.hideError();
        if (!username || !password) {
            this.showError("Please fill in all fields.");
            return;
        }
        btn.disabled = true;
        btn.textContent = "Logging in...";
        try {
            const response = await fetch("../php/Login.php", {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: new URLSearchParams({ username, password }).toString(),
                credentials: "include"
            });
            const data = await response.json();
            if (response.ok && data.success) {
                window.location.href = "/php/Panel.php";
            }
            else {
                this.showError(data.message || "Invalid credentials.");
            }
        }
        catch (error) {
            this.showError("Something went wrong. Please try again.");
            throw new Error(`Error while proceeding on login: ${error}`);
        }
        finally {
            btn.disabled = false;
            btn.textContent = "Login";
        }
    }
    showError(message) {
        const el = this.querySelector("#loginError");
        el.textContent = message;
        el.style.display = "block";
    }
    hideError() {
        const el = this.querySelector("#loginError");
        el.textContent = "";
        el.style.display = "none";
    }
}
customElements.define("app-admin", ClientSideLoginPage);
export default ClientSideLoginPage;
